(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('change', this.onChange.bind(this));
      this.form.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
    }

    disconnectedCallback() {
      clearTimeout(this._priceTimer);
    }

    onSubmit(e) {
      e.preventDefault();
      const url = new URL(this.form.action);
      const defaultSort = this.form.querySelector('[name="sort_by"]')?.dataset.default;
      new FormData(this.form).forEach((val, key) => {
        if (val === '') return;
        if (key === 'sort_by' && val === defaultSort) return;
        url.searchParams.set(key, val);
      });
      this.navigate(url.toString());
    }

    onChange(e) {
      if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') {
        this.form.requestSubmit();
      }
    }

    onInput(e) {
      if (!e.target.classList.contains('filter-price__input')) return;
      clearTimeout(this._priceTimer);
      this._priceTimer = setTimeout(() => this.form.requestSubmit(), 800);
    }

    onClick(e) {
      const link = e.target.closest('.filter-pill, .filter-clear-all');
      if (link) {
        e.preventDefault();
        this.navigate(link.href);
        return;
      }

      const toggle = e.target.closest('.filters-toggle');
      if (toggle) {
        const groups = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!groups) return;
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        groups.toggleAttribute('data-open', !open);
      }
    }

    async navigate(url) {
      if (this._loading) return;
      this._loading = true;

      try {
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        this.swapLoadMore(doc);
        this.swap(doc, 'hommegirls-product-grid');
        history.pushState({}, '', url);
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Swap self last — disconnects this instance, new instance takes over
        const next = doc.querySelector('collection-filters');
        if (next) this.replaceWith(next);
      } catch {
        window.location = url;
      }
    }

    swap(doc, selector) {
      const next = doc.querySelector(selector);
      const curr = document.querySelector(selector);
      if (next && curr) curr.replaceWith(next);
    }

    swapLoadMore(doc) {
      const next = doc.querySelector('.collection__load-more')?.closest('p');
      const curr = document.querySelector('.collection__load-more')?.closest('p');
      if (curr && next) curr.replaceWith(next);
      else if (curr && !next) curr.remove();
      else if (!curr && next) document.querySelector('hommegirls-product-grid')?.after(next);
    }
  }

  customElements.define('collection-filters', CollectionFilters);
  } catch(e) { console.error(e); }
})();

})();
